import React, { useState } from 'react';
import DefaultSetupPage from './DefaultSetupPage';
import ManageBankAccounts from './ManageBankAccounts';

function Setup() {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <div>
      <div className="startinventoryOuter">
        <div className="startinventory">
          {activeTab === 1 && <DefaultSetupPage setActiveTab={setActiveTab} />}
          {activeTab === 2 && <ManageBankAccounts setActiveTab={setActiveTab} />}
        </div>
      </div>
    </div>
  )
}

export default Setup;
